"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const react_2 = require("@osmosys/react");
const AdSalesMaterials_1 = require("./AdSalesMaterials");
const AdCampaigns_1 = require("./AdCampaigns");
const AdTearSheets_1 = require("./AdTearSheets");
const AdWorkflows_1 = require("./AdWorkflows");
const AdCreativesList_1 = require("./AdCreativesList");
const AdUnitsList_1 = require("./AdUnitsList");
exports.AdsManagerBrochure = () => {
    return (react_1.default.createElement(react_2.OsmosysDiv, { padding: true },
        react_1.default.createElement(reactstrap_1.Card, { body: true, className: "my-2 shadow mx-auto", style: { maxWidth: 1200 } },
            react_1.default.createElement(exports.AdsManagerBrochureHeader, null),
            react_1.default.createElement(AdSalesMaterials_1.AdsManagerAdBrochureSalesMaterials, null),
            react_1.default.createElement(AdCampaigns_1.AdsManagerBrochureAdCampaigns, null),
            react_1.default.createElement(AdUnitsList_1.AdsManagerAdUnitsList, null),
            react_1.default.createElement(AdCreativesList_1.AdsManagerBrochureAdCreativesList, null),
            react_1.default.createElement(AdWorkflows_1.AdsManagerBrochureAdWorkflows, null),
            react_1.default.createElement(AdTearSheets_1.AdsManagerBrochureAdTearSheets, null))));
};
exports.AdsManagerBrochureHeader = () => {
    return (react_1.default.createElement(react_2.OsmosysDiv, { flexRow: true },
        react_1.default.createElement(react_2.OsmosysDiv, { flexColCenteredFilled: true },
            react_1.default.createElement("h1", { className: "m-0" }, "Ads Manager"),
            react_1.default.createElement("p", { className: "lead mb-2", style: { maxWidth: 800 } }, "From sales to creatives to production, Ads Manager is here to help you coordinate large and small advertising operations. Avoid bottlenecks, and empower Newsletter Managers, Editors, Advertisers, and Ad Operations each step of the way.")),
        react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true, marginLeft: true },
            react_1.default.createElement(react_2.OsmosysDiv, { flexRow: true },
                react_1.default.createElement(react_2.OsmosysButton, { osysName: "Demo", to: "/ads/manager/preview", osysIcon: "arrowRight", iconPosition: "right", className: "mr-2" }, "Preview"),
                ' ',
                react_1.default.createElement(react_2.OsmosysButton, { osysName: "Demo", to: "/ads", osysIcon: "arrowRight", iconPosition: "right" }, "Open Demo")))));
};
exports.default = exports.AdsManagerBrochure;
//# sourceMappingURL=index.js.map